var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('search-nav-start-end',{attrs:{"label":"발생일자"},model:{value:(_vm.nav.inputB_6),callback:function ($$v) {_vm.$set(_vm.nav, "inputB_6", $$v)},expression:"nav.inputB_6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }